import {
  DESTROY_BACKDROP,
  FETCH_SPONSORS_FOR_CMO,
  OPEN_BACKDROP,
 } from "../../actions/types";

const initialState = {};

const sponsorAPIReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SPONSORS_FOR_CMO:
      return {
        ...state,
        sponsorsListForCmo: action.payload, // Update the state with the fetched data
      };
    case OPEN_BACKDROP:
      return {
        ...state,
        backdropLoading: true,
        backdropText: action.backdropText
          ? action.backdropText
          : `Please don't refresh or close the tab while processing`,
      };

    case DESTROY_BACKDROP:
      return {
        ...state,
        backdropLoading: false,
      };
    default:
      return state;
  }
};

export default sponsorAPIReducer;
